import React from 'react';
import { storiesOf } from '@storybook/react';
import CaseFilterModal from './CaseFilterModal';
import { action } from '@storybook/addon-actions';

storiesOf('Advanced Search/Result Form/Modals', module)
  .add('CaseFilterModal', () => (
    <CaseFilterModal
      show
      onClose={() => null}
      onSave={action('submitAdvancedSearch')}
      filter={filter}
    />
  ));

const filter = {};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/CaseFilterModal.stories.jsx